import Axios from 'axios';
import { Localization } from '../localization/localization';
import { RegistrationError } from './RegistrationErorr';
import { NetworkError } from '../shared/errors/NetworkError';
import { configureHttpAuth } from '../startup/configureHttpAuth';
import { RegistrationProtocol } from './registrationProtocol';
import { registrationV4 } from '../general/modules/registration_popup/registrationV4';

type RegistrationRequestResult = {
    huid?: number;
    error?: {
        code: number,
        message: string
    };
};

export type RegistrationResult = [boolean, Error?];

export class EmailRegistration {
    public static async register(regData: RegistrationProtocol): Promise<RegistrationResult> {
        Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

        return this.registerThroughHub(regData)
            .then((result): RegistrationResult => {
                if (result.error) {
                    return [false, new RegistrationError(result.error.message)];
                }

                window.app.user_huid = result.huid;
                configureHttpAuth();
                return [true, void (0)];
            })
            .catch((error): RegistrationResult => {
                console.error(error);
                window.Sentry.captureException(new NetworkError(Localization._n('common_error')));
                return [false, new RegistrationError(Localization._n('common_error'))];
            });
    }

    protected static async registerThroughHub(regData: RegistrationProtocol): Promise<RegistrationRequestResult> {
        try {
            const response = await registrationV4(regData);

            if ('error' in response) {
                return { error: response.error };
            }

            if ('result' in response && 'huid' in response.result) {
                return { huid: response.result.huid };
            }

            console.log('Unexpected response from registrationV4', response);
            return { error: { code: -1, message: Localization._n('common_error') } };
        } catch (error) {
            return { error };
        }
    }

    protected static getAction() {
        return 'registration';
    }
}
